// 要素
const allSchedule = document.getElementById('js-allSchedule');

// オブザーバインスタンスを作成
const observer = new MutationObserver(records => {
  // 変化が発生したときの処理を記述
  page_anchor();
});
// 監視の開始
observer.observe(allSchedule, {
  // オプションを指定
  attributes: true, // 属性の変化を監視
  childList: true, // 子ノードの変化を監視
});

// 全科外来担当医表
function getAllSchedule(){
  const requestUrl = 'https://kotobuki-ent.com/system/higashi-kawaguchi/all-schedule.php'; // 本番サーバー
  //const requestUrl = 'http://localhost:8288/system/higashi-kawaguchi/all-schedule.php'; // Local

  $.post( requestUrl, function( data ){
    setTimeout(function() {
      allSchedule.innerHTML = data;
      popupModal(); // ポップアップ処理
    }, 1000);

  });
}



// Initialize
document.addEventListener('DOMContentLoaded', function() {

  // 全科外来担当医表
  getAllSchedule();

  // body の閉じタグの前にモーダル用のマークアップを追加する
  document.body.insertAdjacentHTML('beforeend', modalMarkup);

});
